import React from 'react';

import { isEmptyArray } from '@travel/utils';

import styles from './basicInformation.module.scss';

export default function CategoryNames(props: { categoryNames: string[] | undefined }) {
  const { categoryNames } = props;

  if (isEmptyArray(categoryNames)) {
    return null;
  }

  return (
    <div
      className={styles.categoryNamesWrapper}
      data-testid="providerInformationPage-basicInformation-categoryNames"
    >
      {categoryNames.map((category, i) => (
        <span className={styles.category} key={i}>
          {category}
        </span>
      ))}
    </div>
  );
}
